<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="h3"></a><span class="caps">Chapter 3</span></h2>
<p class="sectiontop"><span class="dropcap">L</span>ITTLE Sun left the office of the tribe geologist with a heavy heart. He had lived eighty years in peace in Tahlequah, Oklahoma. He had raised seven children and only one of them had died and that was almost twenty years ago. In all this time he had made a good living for his family in different ways and had his check from the Cherokee Nation for renting the land his daddy left him and had always been scrupulously honest and taught his children to be. Now he had this secret to keep. “I do not want it known,” he had told the geologist. “How many will know this?”</p>
<p>“Before long many will know it. You might as well tell them.”</p>
<p>“Then what? My sons will quit their jobs. Everyone will get confused. I don’t like it. How much could I sell my piece of it for?”</p>
<p>“I’m not sure. No one thought anyone would sell it. It would be foolish to sell it, after you kept the oil rights all these years. No, I’d never advise you to do that.”</p>
<p>“I think I want to sell it. Find out how much they would give me.”</p>
<p>“You need to tell your sons.”</p>
<p>“No. When will they find out? All the others.”</p>
<p>“It’s only you, and three more. They won’t be drilling for several months. No one lives in Tahlequah but you. The others live in Oklahoma City.”</p>
<p><a id="page_13"></a>“Don’t tell anyone. I am going now. I have to think of this.” Little Sun walked the block to his truck and climbed into the cab and began to drive slowly back down Muskogee to the railroad track. A lot of money all at once. That would be the worst thing that could happen to them. How many families had he seen ruined by it. He would tell Crow as soon as he got home but no one else. This was just in time to ruin the homecoming of the little girl.</p>
<p>The others live in Oklahoma City. They won’t drill for several months. Summer would come and go and he would think of the best way to keep the oil from drowning all his children. In the evening when the sun left the sky, he would go out and sleep on the earth and ask the stars to help him know the way to go.</p>
<p>He steered the old truck out onto the four-lane and drove along at thirty miles an hour, taking great satisfaction in how unhappy it made the young girls and bucks who wished to pass him.<a id="page_14"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_chapter03.vue?721a357b